import config from "@/data/config";

const env = {
  getters: {
    isDebugMode() {
      return import.meta.env.VITE_DEBUG === "true";
    },
    useAuth() {
      return import.meta.env.VITE_DO_AUTH === "true";
    },
    useDatastore() {
      return import.meta.env.VITE_USE_DATASTORE === "true";
    },
    useLandingPage() {
      return config.settings.useLandingPage === true;
    },
    useNavbar() {
      return config.settings.useNavbar === true;
    },
    publicKey() {
      return import.meta.env.VITE_PUBLIC_KEY;
    }
  }
};

export default env;
